export function promotionListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      adminPlansId: resource.plansId.map((item) => ({plansId : item})),
      adminSpecialistIds: resource.specialistIds.map((item) => ({specialistIds : item})),
      adminClinicCategories: resource.clinicCategories.map((item) => ({clinicCategories : item})),
      adminSpecialistCardIds: resource.specialistCardIds.map((item) => ({specialistCardIds : item})),
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdatePromotionId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixCreatePromotionId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function promotionMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId,
      adminPlansId: json.result.plansId.map((item) => ({plansId : item})),
      adminSpecialistIds: json.result.specialistIds.map((item) => ({specialistIds : item})),
      adminClinicCategories: json.result.clinicCategories.map((item) => ({clinicCategories : item})),
      adminSpecialistCardIds: json.result.specialistCardIds.map((item) => ({specialistCardIds : item})),
    },
  };
}